/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */

import React, { useContext } from 'react';
import { DarkModeContext } from '../../common/contexts/darkMode';

import {
  Container,
  Card,
  IconWrapper,
  Content,
  Title,
  Value,
} from './styles';

function MetricsCards({ items = [] }) {
  const { toggleMode } = useContext(DarkModeContext)
  return (
    <Container>
      {items.map((item, index) => (
        <Card darkMode={toggleMode} key={index}>
          <IconWrapper background={item.background} color={item.color}>
            {item.icon}
          </IconWrapper>

          <Content>
            <Title>{item.title}</Title>

            <Value style={{ color: toggleMode ? 'white' : '#1a1d24' }}>{item.value}</Value>
          </Content>
        </Card>
      ))}
    </Container>
  );
}

export default MetricsCards;